import { api } from '@/api/client';
import type {
  SuperadminInvoiceApiResponse,
  GenerateInvoiceRequest,
  ResendInvoiceRequest,
} from '../pages/invoice/types';

export const superadminInvoicesService = {
  /**
   * ✅ List invoices
   * API: GET /backoffice/api/v1/invoices/
   * (Body-based filters)
   */
  async list(payload: {
    merchant_uuid?: string;
    date_from?: string;
    date_to?: string;
    invoice_status?: string;
    invoice_id?: string;
    page?: number;
    page_size?: number;
  }): Promise<SuperadminInvoiceApiResponse> {
    return api.get<SuperadminInvoiceApiResponse>(
      '/backoffice/api/v1/invoices/',
      {
        params: payload, // ✅ CORRECT
      }
    );
  },
  /**
   * ✅ Generate Invoice
   */
  async generate(payload: GenerateInvoiceRequest) {
    return api.post('/backoffice/api/v1/generate-invoice/', payload);
  },

  /**
   * ✅ Resend Invoice
   */
  async resend(payload: ResendInvoiceRequest) {
    return api.post('/backoffice/api/v1/resend-invoice/', payload);
  },

  /**
   * ✅ Download Invoice - returns download link
   */
  async download(invoiceUuid: string): Promise<{ success: boolean; download_link: string }> {
    return api.get(`/backoffice/api/v1/download-invoice/`, {
      params: { invoice_id: invoiceUuid },
    });
  },


  /**
   * ✅ List Merchants
   */
  async listMerchants() {
    return api.get('/backoffice/api/v1/merchants/');
  },







};
